import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_REVIEW_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerReviewRoutes: RouteRecordRaw = {
  path: '/customer-review',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: CUSTOMER_REVIEW_ROUTE_NAME.CUSTOMER_REVIEW,
      path: '',
      component: () => import('./CustomerReview.vue'),
    },
  ],
};
